function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.18
}, /*#__PURE__*/React.createElement("path", {
  d: "M1570.59,1040.89l-180.57-271.12c84.18-69.76,133.72-155.12,133.72-247.33c0-235.53-323.13-426.46-721.73-426.46 S80.27,286.92,80.27,522.45S403.4,948.91,802,948.91c104.97,0,204.69-13.25,294.67-37.06L1570.59,1040.89z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#1991FC",
  d: "M1586.3,1006.53l-180.57-271.12c84.18-69.76,133.72-155.12,133.72-247.33 c0-235.53-323.13-426.46-721.73-426.46S95.98,252.56,95.98,488.09s323.13,426.46,721.73,426.46 c104.97,0,204.69-13.25,294.67-37.06L1586.3,1006.53z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_1_",
  d: "M1586.3,1006.53l-180.57-271.12c84.18-69.76,133.72-155.12,133.72-247.33 c0-235.53-323.13-426.46-721.73-426.46S95.98,252.56,95.98,488.09s323.13,426.46,721.73,426.46 c104.97,0,204.69-13.25,294.67-37.06L1586.3,1006.53z"
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_2_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_1_",
  overflow: "visible"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#24B6FB",
  d: "M1577.05,967.58l-180.57-271.12c84.18-69.76,133.72-155.12,133.72-247.33 c0-235.53-323.13-426.46-721.73-426.46S86.73,213.61,86.73,449.14S409.86,875.6,808.47,875.6 c104.97,0,204.69-13.25,294.67-37.06L1577.05,967.58z"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_3_",
  d: "M1577.05,967.58l-180.57-271.12c84.18-69.76,133.72-155.12,133.72-247.33 c0-235.53-323.13-426.46-721.73-426.46S86.73,213.61,86.73,449.14S409.86,875.6,808.47,875.6 c104.97,0,204.69-13.25,294.67-37.06L1577.05,967.58z"
}));

var _ref8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_4_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_3_",
  overflow: "visible"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_4_)",
  fill: "url(#SVGID_5_)",
  d: "M1160.04,1050.32c-90.99,208.94-490.3,236.55-891.88,61.66 s-653.37-486.03-562.38-694.97s490.3-236.55,891.88-61.66S1251.03,841.38,1160.04,1050.32z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_4_)",
  fill: "url(#SVGID_6_)",
  d: "M1926.94,481.59c-90.99,208.94-490.3,236.55-891.88,61.66 S381.69,57.22,472.68-151.71s490.3-236.55,891.88-61.66S2017.93,272.65,1926.94,481.59z"
});

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M1581.02,1011.16l-180.57-271.12c84.18-69.76,133.71-155.12,133.71-247.33 c0-235.53-323.13-426.46-721.73-426.46S90.7,257.19,90.7,492.71s323.13,426.46,721.73,426.46c104.97,0,204.69-13.25,294.67-37.06 L1581.02,1011.16z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M1619.26,1030.35l-506.94-138.04c-93.06,24.27-192.15,36.57-294.6,36.57 c-195.26,0-379.04-45.05-517.5-126.87C159.37,718.79,81.8,607.31,81.8,488.09c0-119.21,77.57-230.7,218.42-313.93 C438.67,92.35,622.46,47.29,817.71,47.29s379.04,45.05,517.5,126.87c140.85,83.22,218.42,194.71,218.42,313.93 c0,90.3-44.55,176.51-129.01,250.01L1619.26,1030.35z M1112.43,862.65l440.91,120.06L1386.76,732.6l9.98-8.27 c84.08-69.67,128.52-151.36,128.52-236.24c0-227.25-317.41-412.12-707.55-412.12S110.16,260.84,110.16,488.09 s317.41,412.13,707.55,412.13c101.37,0,199.3-12.31,291.08-36.6L1112.43,862.65z"
}));

var SvgSpeechBubble01 = function SvgSpeechBubble01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "1680px",
    height: "1080px",
    viewBox: "0 0 1680 1080",
    enableBackground: "new 0 0 1680 1080",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, _ref5, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref6, /*#__PURE__*/React.createElement("g", null, _ref7, _ref8, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 138.5687,
    cy: -15.405,
    r: 501.3568,
    gradientTransform: "matrix(1.4503 0.6316 -0.3286 0.7546 226.8797 657.7771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28D8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27D4FB",
      stopOpacity: 0
    }
  })), _ref9, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 439.5045,
    cy: -1020.9943,
    r: 501.3568,
    gradientTransform: "matrix(1.4503 0.6316 -0.3286 0.7546 226.8797 657.7771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28D8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27D4FB",
      stopOpacity: 0
    }
  })), _ref10))), _ref11, _ref12));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeechBubble01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SpeechBubble-01.dbd078f0.svg";
export { ForwardRef as ReactComponent };